import React from "react";
import { Link } from "react-router-dom";
import "./components.css";
function Footer() {
  return (
    <footer className="bg-dark text-white pt-5 pb-3">
      <div className="container">

        <div className="row">

          {/* About */}
          <div className="col-md-4 mb-4">
            <h5 className="fw-bold">JODUST</h5>
            <p>
              Profesionalna ALU i PVC stolarija. Ugradnja prozora, vrata,
              roletni, komarnika i ograda. Kvalitet, preciznost i dug vek trajanja.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-4 mb-4">
            <h5 className="fw-bold">Navigacija</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/" className="text-white text-decoration-none">
                  Početna
                </Link>
              </li>
              <li>
                <Link to="/Blog" className="text-white text-decoration-none">
                  Naši radovi
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white text-decoration-none">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/katalog" className="text-white text-decoration-none">
                  Katalog
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white text-decoration-none">
                  O nama
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-md-4 mb-4">
            <h5 className="fw-bold">Kontakt</h5>
            <ul className="list-unstyled">
              <li>+381000000000</li>
              <li>info@jodust.rs</li>
              <li>Svetog Save 13, Lebane, Leskovac</li>
            </ul>
          </div>

        </div>

        <hr className="border-secondary" />

        <div className="text-center small">
          &copy; {new Date().getFullYear()} JODUST. Sva prava zadržana.
        </div>

      </div>
    </footer>
  );
}

export default Footer;